import common from 'store/modules/common/api'

export const api = {
  deleteAllBottles: () => common.httpClient.delete(`/api/services/app/TemporaryService/DeleteAllBottles`, common.options(120000)).then(r => common.processResponse(r)),
}
